import styled from "styled-components"
import Graphic from "../../assets/images/login_graphic.svg"
import Pig from "../../assets/images/pig_fun.png"
import { COLORS, SCREEN_SIZES } from "../../constants"
import { Row, Col } from "reactstrap"
import { CustomInput, CustomButton } from "../../components"
import { Link } from "react-router-dom"
import { useHistory } from "react-router-dom";
import { useState } from "react"
import { validateEmail } from "../../features"
import { setLoggedUser, setUserRole } from "../../redux/actions"
import { useDispatch } from "react-redux"
import ReactLoading from "react-loading"
import Eye from "../../assets/images/eye.svg"
import CrossedEye from "../../assets/images/eye_crossed.svg"
import ReactModal from 'react-modal';
import axios from 'axios';

const StyledCol = styled(Col)`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledRow = styled(Row)`
    padding: 50px;
    @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
        padding: 20px 0;
    }
`;
const StyledHeader = styled.h5`
  color: ${COLORS.text_green};
`;
const StyledLabel = styled.div`
  text-align: start;
  color: ${COLORS.text_grey};
`;
const StyledPig = styled.img`
   width: 250px;
   z-index: 0;
   @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
       width: 200px;
    }
`;
const StyledSideGreen = styled.img`
  position: absolute;
  height: 80%;
  left: 0;
  bottom: 0;
  z-index: 1;

  @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
      display: none;
    }
`;
const StyledForm = styled.form`
    width: 80%;
    @media only screen and (max-width: ${SCREEN_SIZES.sm}) {
      width: 100%;
      padding: 20px;
    }
`;
const EyeImage = styled.img`
    position: absolute; 
    top:  ${props => props.crossed ? "9px" : "14.95px"}; 
    right: 10px;
    cursor: pointer;
    transition: 0.2s opacity;
    &:hover{
        opacity: 0.2;
    }
  
`;
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 10,
        border: 0,
    },
    overlay: {
        backgroundColor: "rgba(0,0,0, 0.5)",
        zIndex: 999,
    }
};
const StyledCopyright = styled.div`
   position: absolute;
   bottom: 10px;
   z-index: 99;
   left: 10px;
   font-size: 12px;
   color: ${COLORS.text_dark_green};
`;
export function Login() {
    const api = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(false);
    const [statusCode, setStatusCode] = useState(-200);
    const [password, setPassword] = useState('');
    const [emailOrID, setEmailOrID] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [serverError, setServerError] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [passwordShown, setPasswordShown] = useState(false);

    const history = useHistory();
    const dispatch = useDispatch();

    const loginUser = (result) => {
        localStorage.setItem('role', result.user_role);
        localStorage.setItem('authToken', result.access_token);
        localStorage.setItem('user', JSON.stringify(result)); //changed here
        dispatch(setLoggedUser(result)); //changed here
        dispatch(setUserRole(result.user_role));
    }
    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateEmail(emailOrID)) {

            setLoading(true);
            axios.post(`${api}/login_cp`, {
                pupil_id: emailOrID,
                password: password

            }, {
                headers: {
                    'Accept': 'application/json'
                }
            }).then(res => {
                const result = res.data;

                if (result.message) {
                    setStatusCode(result.status_code)
                    setLoading(false);
                    setServerError(result.message);
                    setModalOpen(true);

                }
                if (result.user) {
                    loginUser(result);
                    setLoading(false);
                    history.replace('/dashboard');
                }
            }).catch(error => {
                console.log(error);
                setLoading(false);
            });
        } else if (validateEmail(emailOrID)) {
            setLoading(true);

            axios.post(`${api}/login`, {
                email: emailOrID,
                password: password
            }, {
                headers: {
                    'Accept': 'application/json'
                }
            }).then(res => {
                const result = res.data;
                setLoading(false)
                if (result.message) {
                    setModalOpen(true);
                    setStatusCode(result.status_code)
                    setServerError(result.message);
                }
                if (result.user) {
                    loginUser(result);

                    history.replace('/dashboard');
                }
            }).catch(error => {
                setModalOpen(true);

                setLoading(false);
            });
        }
    }
    return (
        <>
            <ReactModal ariaHideApp={false} isOpen={modalOpen} contentLabel="Error" role="dialog" style={customStyles} onRequestClose={() => setModalOpen(false)}>
                <div className="d-flex flex-column align-items-center">
                    <h5>Error</h5>
                    <div className="text-center">{serverError}</div>
                    <div className="d-flex">

                        <CustomButton
                            style={{ width: 200, marginTop: 10 }}
                            color={COLORS.dark_orange}
                            bgColor={COLORS.orange}
                            hover={COLORS.orange_hover}
                            onClick={() => setModalOpen(false)}
                        >
                            Close
                        </CustomButton>
                        {statusCode == -102 && <CustomButton
                            style={{ width: 200, marginTop: 10, marginLeft: 10 }}
                            color={COLORS.text_dark_green}
                            bgColor={COLORS.green}
                            hover={COLORS.text_green}
                            onClick={() => history.push('/resend_verification')}
                        >
                            Resend Email
                        </CustomButton>}
                    </div>
                </div>
            </ReactModal>
            <StyledRow className="m-0 h-100">
                <StyledSideGreen src={Graphic} />
                <StyledCopyright className="d-none d-lg-block">

                    <div>Copyright 2021</div>
                    <div>UK English Version</div>
                </StyledCopyright>
                <Col lg className="p-0 w-100 d-flex justify-content-center align-items-center position-relative">
                    <StyledPig src={Pig} />
                </Col>
                <StyledCol lg>

                    <StyledForm autoComplete="off">
                        <StyledHeader>Welcome!</StyledHeader>
                        <StyledLabel>Email or ID</StyledLabel>
                        <CustomInput name="email" className="w-100" type="email" value={emailOrID} onChange={(event) => {
                            setEmailOrID(event.target.value)
                            setEmailError('')
                        }} />
                        <div className="text-left" style={{ fontSize: 14, color: "red" }}>{emailError}</div>
                        <StyledLabel className="mt-3">Password</StyledLabel>
                        <div style={{ position: "relative" }}>
                            <CustomInput name="password" type={passwordShown ? "text" : "password"} className="w-100" value={password} onChange={(event) => {
                                setPassword(event.target.value)
                                setPasswordError('')
                            }} />
                            <EyeImage crossed={passwordShown} src={passwordShown ? Eye : CrossedEye} width="30" onClick={() => setPasswordShown(!passwordShown)} />
                        </div>

                        <div className="text-left" style={{ fontSize: 14, color: "red" }}>{passwordError}</div>
                        <CustomButton
                            className="mt-4 w-100"
                            color={COLORS.text_dark_green}
                            bgColor={COLORS.green}
                            hover={COLORS.text_green}
                            disabled={loading}
                            onClick={handleSubmit}
                        >
                            {loading ? <><ReactLoading type="spin" color={COLORS.text_dark_green} height={20} width={20} className="d-inline-block" /><span className="ml-2">Loading...</span></> : 'Login'}
                        </CustomButton>
                        <div className="d-flex flex-row justify-content-between mt-4">
                            <span style={{ color: COLORS.text_grey }}>Not registered?</span>
                            <Link to="/register" className="hover-text-green">Register</Link>
                        </div>
                        <div className="text-center mt-2">
                            <Link to="/password_forgotten" className="hover-text-green">Forgotten password?</Link>
                        </div>

                        <div className="d-sm-block d-lg-none color-text-grey" style={{ fontSize: 14, marginTop: 30 }}>
                            <div>Copyright 2021. UK English Version</div>
                        </div>
                    </StyledForm>
                </StyledCol>
            </StyledRow>
        </>
    );
}